import { render, staticRenderFns } from "./Product_5.vue?vue&type=template&id=1c55b59a&"
import script from "./Product_5.vue?vue&type=script&lang=js&"
export * from "./Product_5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports